module.exports = __webpack_public_path__ + "static/img/swiper_bg.38ee824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper_bg.png
// module id = 5ndg
// module chunks = 1